module.exports = __webpack_public_path__ + "img/example.ad57c2d2.png";